<template>
  <div class="oil-order-container">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-wrapper">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/Welcome' }">
          <i class="el-icon-s-home"></i>首页
        </el-breadcrumb-item>
        <el-breadcrumb-item>
          <i class="el-icon-tickets"></i>喜鹊加油订单列表
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主内容卡片 -->
    <el-card class="main-card" shadow="never">
      <!-- 搜索筛选区域 -->
      <div class="search-section">
        <div class="search-header">
          <div class="title-with-filter">
            <h3 class="section-title">
              <i class="el-icon-search"></i>筛选查询
            </h3>
            <div class="toggle-button" @click="isCollapsed = !isCollapsed">
              <span class="toggle-text">筛选条件</span>
              <i :class="collapseIcon" class="toggle-icon"></i>
            </div>
          </div>
        </div>

        <el-collapse-transition>
          <div v-show="!isCollapsed" class="search-form-wrapper">
            <el-form
                    size="mini"
                    :inline="true"
                    :model="searchForm"
                    ref="searchForRef"
                    class="search-form"
                    label-width="85px"
            >
              <el-row :gutter="24">
                <el-col :span="8">
                  <el-form-item label="关键字">
                    <el-input
                            v-model="searchForm.keyword"
                            placeholder="订单号/司机/车牌"
                            prefix-icon="el-icon-search"
                            clearable
                            @input="goSearch"
                    ></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item label="开票状态">
                    <el-select
                            v-model="searchForm.is_invoice"
                            placeholder="全部"
                            clearable
                            @change="goSearch"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option label="已开票" value="1"></el-option>
                      <el-option label="未开票" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>

                <el-col :span="8">
                  <el-form-item label="支付状态">
                    <el-select
                            v-model="searchForm.pay_status"
                            placeholder="全部"
                            clearable
                            @change="goSearch"
                    >
                      <el-option label="全部" value=""></el-option>
                      <el-option label="已支付" value="2"></el-option>
                      <el-option label="待支付" value="0"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row :gutter="24">
                <el-col :span="12">
                  <el-form-item label="创建时间">
                    <el-date-picker
                            v-model="searchForm.start_end_date"
                            type="datetimerange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期"
                            format="yyyy-MM-dd HH:mm:ss"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            :default-time="['00:00:00', '23:59:59']"
                            :picker-options="datePickerOptions"
                            @change="handleDateChange"
                            style="width: 100%;"
                    ></el-date-picker>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>

      <!-- 数据统计卡片 -->
      <div class="stats-section">
        <h3 class="section-title">
          <i class="el-icon-data-analysis"></i>数据统计
        </h3>
        <el-row :gutter="24" class="stats-cards">
          <el-col :span="6">
            <el-card class="stats-card" shadow="hover">
              <div class="stats-content">
                <div class="stats-icon primary">
                  <i class="el-icon-money"></i>
                </div>
                <div class="stats-info">
                  <div class="stats-label">订单总金额</div>
                  <div class="stats-value amount">
                    ¥{{ formatNumber(filteredStats.totalTradeAmount) }}
                  </div>
                  <div class="stats-count">共 {{ filteredStats.totalCount }} 笔</div>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="6">
            <el-card class="stats-card" shadow="hover">
              <div class="stats-content">
                <div class="stats-icon warning">
                  <i class="el-icon-document"></i>
                </div>
                <div class="stats-info">
                  <div class="stats-label">待开票金额</div>
                  <div class="stats-value">
                    ¥{{ formatNumber(filteredStats.uninvoicedAmount) }}
                  </div>
                  <div class="stats-count">{{ filteredStats.uninvoicedCount }} 笔未开</div>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="6">
            <el-card class="stats-card" shadow="hover">
              <div class="stats-content">
                <div class="stats-icon success">
                  <i class="el-icon-wallet"></i>
                </div>
                <div class="stats-info">
                  <div class="stats-label">已开票金额</div>
                  <div class="stats-value">
                    ¥{{ formatNumber(filteredStats.invoicedAmount) }}
                  </div>
                  <div class="stats-count">{{ filteredStats.invoicedCount }} 笔已开</div>
                </div>
              </div>
            </el-card>
          </el-col>

          <el-col :span="6">
            <el-card class="stats-card" shadow="hover">
              <div class="stats-content">
                <div class="stats-icon info">
                  <i class="el-icon-bank-card"></i>
                </div>
                <div class="stats-info">
                  <div class="stats-label">已支付金额</div>
                  <div class="stats-value">
                    ¥{{ formatNumber(filteredStats.totalTradeAmount) }}
                  </div>
                  <div class="stats-count">支付率 {{ filteredStats.paymentRate }}%</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>
        <el-row :gutter="24" class="stats-cards" style="margin-top: 12px">
          <el-col :span="6">
            <el-card class="stats-card" shadow="hover">
              <div class="stats-content">
                <div class="stats-icon info">
                  <i class="el-icon-bank-card"></i>
                </div>
                <div class="stats-info">
                  <div class="stats-label">可提现金额</div>
                  <div class="stats-value">
                    ¥{{ formatNumber(filteredStats.unwithdrawAmount) }}
                  </div>
                  <div class="stats-count">{{ filteredStats.unwithdrawCount }} 笔已开</div>
                </div>
              </div>
            </el-card>
          </el-col>
          <el-col :span="6">
            <el-card class="stats-card" shadow="hover">
              <div class="stats-content">
                <div class="stats-icon info">
                  <i class="el-icon-bank-card"></i>
                </div>
                <div class="stats-info">
                  <div class="stats-label">已提现金额</div>
                  <div class="stats-value">
                    ¥{{ formatNumber(filteredStats.withdrawAmount) }}
                  </div>
                  <div class="stats-count">{{ filteredStats.withdrawCount }} 笔已开</div>
                </div>
              </div>
            </el-card>
          </el-col>
        </el-row>

      </div>

      <!-- 订单表格 -->
      <div class="table-section">
        <div class="table-header">
          <h3 class="section-title">
            <i class="el-icon-list"></i>订单列表
          </h3>
          <div class="table-actions">
            <el-tooltip content="刷新数据" placement="top">
              <el-button
                      size="small"
                      icon="el-icon-refresh"
                      circle
                      @click="refreshData"
              ></el-button>
            </el-tooltip>
            <el-tooltip content="导出数据" placement="top">
              <el-button
                      size="small"
                      type="primary"
                      icon="el-icon-download"
                      @click="exportData"
              >
                导出
              </el-button>
            </el-tooltip>
          </div>
        </div>

        <el-table
                :data="filteredTableData"
                stripe
                style="width: 100%"
                class="order-table"
                size="small"
                v-loading="loading"
                @sort-change="handleSortChange"
        >
          <el-table-column type="index" label="序号" width="60" align="center" fixed="left">
            <template slot-scope="scope">
              <span class="index-number">{{ (pageNum - 1) * pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  label="交易单号"
                  width="160"
                  align="center"
                  sortable="custom"
          >
            <template slot-scope="scope">

              {{ scope.row.flow_id }}

            </template>
          </el-table-column>
          <el-table-column
                  label="交易日期"
                  width="160"
                  align="center"
                  sortable="custom"
          >
            <template slot-scope="scope">
              <div class="time-display">
                <div class="date">{{ scope.row.order_pay_time }}</div>
              </div>
            </template>
          </el-table-column>

          <el-table-column
                  prop="order_amount"
                  label="交易金额"
                  width="100"
                  align="right"
                  sortable="custom"
          >
            <template slot-scope="scope">
              <span class="amount-cell">¥{{ formatNumber(scope.row.trade_amount) }}</span>
            </template>
          </el-table-column>
          <el-table-column
                  prop="order_amount"
                  label="提现金额"
                  width="100"
                  align="right"
                  sortable="custom"
          >
            <template slot-scope="scope">
              <div class="amount-cell">¥{{ formatNumber(scope.row.withdraw_amount) }}</div>
              <div >{{scope.row.withdraw?timeFormat(scope.row.withdraw.add_time):''}}</div>

            </template>
          </el-table-column>



          <el-table-column label="采购点" min-width="120">
            <template slot-scope="scope">
              <div class="company-display">
                <el-tooltip :content="scope.row.shop_name || '-'" placement="top">
                  <span>{{ scope.row.shop_name || '-' }}</span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="开票状态" width="120" align="center">
            <template slot-scope="scope">
              <div class="invoice-status">
                <el-tag
                        size="small"
                        :type="scope.row.is_invoice == 1 ? 'success' : 'warning'"
                        :effect="scope.row.is_invoice == 1 ? 'plain' : 'light'"
                >
                  {{ scope.row.is_invoice == 1 ? '已开票' : '未开票' }}
                </el-tag>
                <div v-if="scope.row.is_invoice == 1 && scope.row.time_invoice" class="invoice-time">
                  {{ scope.row.time_invoice | timeFormat }}
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="提现状态" width="120" align="center">
            <template slot-scope="scope">
              <div class="invoice-status">
                <el-tag
                        size="small"
                        :type="scope.row.is_withdraw == 1 ? 'success' : 'warning'"
                        :effect="scope.row.is_withdraw == 1 ? 'plain' : 'light'"
                >
                  {{ scope.row.is_withdraw == 1 ? '已提现' : '未提现' }}
                </el-tag>

              </div>
            </template>
          </el-table-column>
<!--          <el-table-column label="付款方式" width="100" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              {{ scope.row.payment_method }}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="支付时间" width="100" align="center">
            <template slot-scope="scope">
              {{ scope.row.order_pay_time }}
            </template>
          </el-table-column>
<!--          <el-table-column label="支付单号" width="100" align="center">-->
<!--            <template slot-scope="scope">-->
<!--              {{ scope.row.pay_channel_order_no }}-->
<!--            </template>-->
<!--          </el-table-column>-->
          <el-table-column label="支付状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag
                      size="small"
                      :type="getPaymentStatusType(scope.row.pay_status)"
              >
                {{ getPaymentStatusText(scope.row.pay_status) }}
              </el-tag>
            </template>
          </el-table-column>

          <el-table-column label="操作" width="120" align="center" fixed="right">
            <template slot-scope="scope">
              <div class="action-buttons">
                <!-- 上传发票 -->
                <el-tooltip
                        content="上传发票"
                        placement="top"
                        v-if="scope.row.pay_status==2 && !scope.row.file_url"
                >
                  <el-button
                          size="mini"
                          type="text"
                          icon="el-icon-upload"
                          style="color: #ff0000"
                          @click="goInvoice(scope.row)"
                          class="action-btn invoice-btn"
                  ></el-button>
                </el-tooltip>

                <!-- 下载发票 -->
                <el-tooltip
                        content="下载发票"
                        placement="top"
                        v-if="scope.row.file_url"
                >
                  <el-button
                          size="mini"
                          type="text"
                          icon="el-icon-download"
                          @click="downloadFile(scope.row.file_url, `发票_${scope.row.sn}.pdf`)"
                          class="action-btn download-btn"
                  ></el-button>
                </el-tooltip>

                <!-- 下载凭证 -->
<!--                <el-tooltip content="下载凭证" placement="top" v-if="scope.row.pay_channel_order_no">-->
<!--                  <el-button-->
<!--                          size="mini"-->
<!--                          type="text"-->
<!--                          icon="el-icon-document"-->
<!--                          @click="downPay(scope.row)"-->
<!--                          class="action-btn voucher-btn"-->
<!--                  ></el-button>-->
<!--                </el-tooltip>-->

                <!-- 查看详情 -->
                <el-tooltip content="查看详情" placement="top">
                  <el-button
                          size="mini"
                          type="text"
                          icon="el-icon-view"
                          @click="showGoods(scope.row)"
                          class="action-btn detail-btn"
                  ></el-button>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pagination-wrapper">
          <div class="page-info">
            显示 {{ (pageNum - 1) * pageSize + 1 }} 到
            {{ Math.min(pageNum * pageSize, total) }} 条，共 {{ total }} 条记录
          </div>
          <el-pagination
                  background
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pageNum"
                  :page-sizes="[10, 20, 30, 50]"
                  :page-size="pageSize"
                  layout="total, sizes, prev, pager, next, jumper"
                  :total="total"
          ></el-pagination>
        </div>
      </div>
    </el-card>

    <!-- 订单详情抽屉 -->
    <el-drawer
            title="订单详情"
            :visible.sync="drawer"
            :size="drawerSize"
            :with-header="false"
            class="order-detail-drawer"
    >
      <div class="drawer-content" v-if="om">
        <div class="drawer-header">
          <h3 class="drawer-title">
            <i class="el-icon-tickets"></i>订单详情
          </h3>
          <el-button size="small" icon="el-icon-close" @click="drawer = false"></el-button>
        </div>

        <div class="detail-content">
          <!-- 基本信息 -->
          <el-card class="detail-card" shadow="never">
            <template #header>
              <div class="card-header">
                <span class="card-title">
                  <i class="el-icon-info"></i>基本信息
                </span>
                <div class="card-actions">
                  <el-tooltip content="下载凭证" placement="top">
                    <el-button
                            size="mini"
                            type="primary"
                            icon="el-icon-download"
                            @click="downPay(om)"
                    ></el-button>
                  </el-tooltip>
                </div>
              </div>
            </template>

            <el-descriptions :column="2" border size="small">
              <el-descriptions-item label="订单编号">
                <span class="highlight-text">{{ om.sn }}</span>
              </el-descriptions-item>
              <el-descriptions-item label="总金额">
                <span class="highlight-text amount">¥{{ formatNumber(om.order_amount) }}</span>
              </el-descriptions-item>
              <el-descriptions-item label="下单日期">
                {{ om.add_time | timeFormat }}
              </el-descriptions-item>
              <el-descriptions-item label="油站名称">
                {{ om.oilshop?.name || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="运企名称">
                {{ om.lgsshop?.name || '-' }}
              </el-descriptions-item>
              <el-descriptions-item label="司机信息">
                {{ om.owner?.name || '-' }} / {{ om.carinfo?.car_number || '-' }}
              </el-descriptions-item>
            </el-descriptions>
          </el-card>

          <!-- 发票信息 -->
          <el-card class="detail-card" shadow="never" v-if="om.invoice || om.file_url">
            <template #header>
              <div class="card-header">
                <span class="card-title">
                  <i class="el-icon-document"></i>发票详情
                </span>
              </div>
            </template>

            <el-descriptions :column="2" border size="small">
              <template v-if="om.invoice">
                <el-descriptions-item label="名称">{{ om.invoice.name }}</el-descriptions-item>
                <el-descriptions-item label="税号">{{ om.invoice.tax_id }}</el-descriptions-item>
                <el-descriptions-item label="手机号">{{ om.invoice.mobile }}</el-descriptions-item>
                <el-descriptions-item label="邮箱">{{ om.invoice.email || '-' }}</el-descriptions-item>
                <el-descriptions-item label="开票日期">{{ om.time_invoice | timeFormat }}</el-descriptions-item>
              </template>
              <el-descriptions-item label="发票文件">
                <div v-if="om.file_url" class="invoice-file">
                  <el-button
                          type="text"
                          icon="el-icon-download"
                          @click="downloadFile(om.file_url, `发票_${om.sn}.pdf`)"
                  >
                    下载发票
                  </el-button>
                  <div class="file-preview" v-if="isImageFile(om.file_url)">
                    <el-image
                            :src="om.file_url"
                            :preview-src-list="[om.file_url]"
                            class="invoice-image"
                    >
                      <div slot="error" class="image-slot">
                        <i class="el-icon-picture-outline"></i>
                      </div>
                    </el-image>
                  </div>
                </div>
                <span v-else>-</span>
              </el-descriptions-item>
            </el-descriptions>
          </el-card>

          <!-- 商品列表 -->
          <el-card class="detail-card" shadow="never" v-if="goods_list.length > 0">
            <template #header>
              <div class="card-header">
                <span class="card-title">
                  <i class="el-icon-goods"></i>商品清单
                </span>
                <span class="goods-count">共 {{ goods_list.length }} 件商品</span>
              </div>
            </template>

            <el-table :data="goods_list" size="small" stripe>
              <el-table-column type="index" label="序号" width="60" align="center"></el-table-column>
              <el-table-column prop="product_name" label="产品名称" min-width="150"></el-table-column>
              <el-table-column prop="num" label="数量" width="80" align="center">
                <template slot-scope="scope">
                  <span class="goods-quantity">{{ scope.row.num }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="unit" label="单位" width="80" align="center"></el-table-column>
            </el-table>
          </el-card>
        </div>
      </div>
    </el-drawer>

    <!-- 发票上传弹窗 -->
    <eInvoiceForm
            :formData="formData1"
            :visible.sync="visible1"
            :title="title1"
            :closeForm="closeForm1"
            @eventChoose="handleInvoiceUpload"
    />
  </div>
</template>

<script>
  import moment from 'moment'
  import eInvoiceForm from "../common/eInvoiceDayBillForm.vue";

  export default {
    name: "OilOrderList",
    components: {
      eInvoiceForm
    },
    data() {
      return {
        loading: false,
        allTableData: [], // 所有数据
        filteredTableData: [], // 筛选后的数据
        om: null,
        formData1: { item: null },
        visible1: false,
        title1: '',
        isCollapsed: true,
        drawer: false,
        drawerSize: '50%',
        goods_list: [],

        datePickerOptions: {
          shortcuts: [
            {
              text: '今天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '昨天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24);
                end.setTime(end.getTime() - 3600 * 1000 * 24);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近7天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                picker.$emit('pick', [start, end]);
              }
            },
            {
              text: '最近30天',
              onClick(picker) {
                const end = new Date();
                const start = new Date();
                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                picker.$emit('pick', [start, end]);
              }
            }
          ]
        },

        searchForm: {
          is_invoice: '',
          keyword: '',
          start_end_date: '',
          pay_status: ''
        },

        sortConfig: {
          prop: '',
          order: ''
        },

        pageNum: 1,
        pageSize: 10,
        total: 0
      };
    },
    computed: {
      collapseIcon() {
        return this.isCollapsed ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
      },

      // 前端统计计算
      filteredStats() {
        const stats = {
          totalTradeAmount: 0,
          totalAmount: 0,
          totalCount: 0,
          uninvoicedAmount: 0,
          uninvoicedCount: 0,
          invoicedAmount: 0,
          invoicedCount: 0,
          paidAmount: 0,
          unpaidAmount: 0,
          paidCount: 0,
          unpaidCount: 0,


          withdrawAmount: 0,
          unwithdrawAmount: 0,
          withdrawCount: 0,
          unwithdrawCount: 0,
        };

        this.filteredTableData.forEach(order => {
          const amount = parseFloat(order.order_amount) || 0;

          // 总统计
          stats.totalAmount += amount;



          const tradeAmount = parseFloat(order.trade_amount) || 0;

          // 总统计
          stats.totalTradeAmount += tradeAmount;


          stats.totalCount++;

          // 开票统计
          if (order.pay_status == 2&&order.is_invoice == 1) {
            stats.invoicedAmount += amount;
            stats.invoicedCount++;
          } else if(order.pay_status == 2&&order.is_invoice == 0)  {
            stats.uninvoicedAmount += amount;
            stats.uninvoicedCount++;
          }

          // 支付统计
          if (order.pay_status == 2) {
            stats.paidAmount += amount;
            stats.paidCount++;
          } else {
            stats.unpaidAmount += amount;
            stats.unpaidCount++;
          }


          // 提现统计
          if (order.pay_status == 2&&order.is_invoice == 1&&order.is_withdraw == 1) {
            stats.withdrawAmount += amount;
            stats.withdrawCount++;
          } else   if (order.pay_status == 2&&order.is_invoice == 1&&order.is_withdraw == 0){
            stats.unwithdrawAmount += amount;
            stats.unwithdrawCount++;
          }

        });

        // 计算支付率
        stats.paymentRate = stats.totalCount > 0
                ? ((stats.paidCount / stats.totalCount) * 100).toFixed(1)
                : '0.0';

        return stats;
      }
    },
    filters: {
      dateFormat(time) {
        if (!time) return "-";
        return moment(time * 1000).format("YYYY-MM-DD");
      },

      timeFormat(time) {
        if (!time) return "-";
        return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss");
      },

      timeOnlyFormat(time) {
        if (!time) return "";
        return moment(time * 1000).format("HH:mm:ss");
      }
    },
    created() {
      this.DataList();
    },
    mounted() {
      this.updateDrawerSize();
      window.addEventListener('resize', this.updateDrawerSize);
    },
    beforeDestroy() {
      window.removeEventListener('resize', this.updateDrawerSize);
    },
    methods: {
      timeFormat(time) {
        if (!time) return "-";
        return moment(time * 1000).format("YYYY-MM-DD HH:mm:ss");
      },
      updateDrawerSize() {
        this.drawerSize = window.innerWidth < 768 ? '90%' : '50%';
      },

      formatNumber(num) {
        const number = parseFloat(num) || 0;
        return new Intl.NumberFormat('zh-CN', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2
        }).format(number);
      },

      handleDateChange(value) {
        this.searchForm.start_end_date = value;
        this.applyFilters();
      },

      goSearch() {
        this.pageNum = 1;
        this.applyFilters();
      },

      applyFilters() {
        let filtered = [...this.allTableData];

        // 关键字过滤
        const keyword = this.searchForm.keyword?.toLowerCase().trim();
        if (keyword) {
          filtered = filtered.filter(order => {
            return (
                    (order.sn && order.sn.toLowerCase().includes(keyword)) ||
                    (order.owner?.name && order.owner.name.toLowerCase().includes(keyword)) ||
                    (order.carinfo?.car_number && order.carinfo.car_number.toLowerCase().includes(keyword)) ||
                    (order.oilshop?.name && order.oilshop.name.toLowerCase().includes(keyword)) ||
                    (order.lgsshop?.name && order.lgsshop.name.toLowerCase().includes(keyword))
            );
          });
        }

        // 开票状态过滤
        if (this.searchForm.is_invoice !== '') {
          const isInvoice = parseInt(this.searchForm.is_invoice);
          filtered = filtered.filter(order => order.is_invoice == isInvoice);
        }

        // 支付状态过滤
        if (this.searchForm.pay_status !== '') {
          const payStatus = parseInt(this.searchForm.pay_status);
          filtered = filtered.filter(order => order.pay_status == payStatus);
        }

        // 时间范围过滤
        if (this.searchForm.start_end_date && this.searchForm.start_end_date.length === 2) {
          const [startStr, endStr] = this.searchForm.start_end_date;
          const startTime = moment(startStr).valueOf() / 1000;
          const endTime = moment(endStr).valueOf() / 1000;

          filtered = filtered.filter(order => {
            const orderTime = order.add_time;
            return orderTime >= startTime && orderTime <= endTime;
          });
        }

        // 排序
        if (this.sortConfig.prop && this.sortConfig.order) {
          filtered.sort((a, b) => {
            let aVal, bVal;

            if (this.sortConfig.prop === 'add_time') {
              aVal = a.add_time;
              bVal = b.add_time;
            } else if (this.sortConfig.prop === 'order_amount') {
              aVal = parseFloat(a.order_amount) || 0;
              bVal = parseFloat(b.order_amount) || 0;
            }

            if (this.sortConfig.order === 'ascending') {
              return aVal - bVal;
            } else {
              return bVal - aVal;
            }
          });
        }

        // 更新数据
        this.total = filtered.length;
        const start = (this.pageNum - 1) * this.pageSize;
        const end = start + this.pageSize;
        this.filteredTableData = filtered.slice(start, end);
      },

      handleSortChange({ column, prop, order }) {
        console.log(column)
        this.sortConfig = { prop, order };
        this.applyFilters();
      },

      async DataList() {
        this.loading = true;
        try {
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            pageNum: 1,
            pageSize: 1000, // 获取更多数据用于前端分析
          };

          const res = await this.$axios.findDayBillOilByUserListP(param);
          if (res.code === 200) {
            this.allTableData = res.data.data || [];
            this.applyFilters();
          }
        } catch (error) {
          console.error('加载订单列表失败:', error);
          this.$message.error('加载订单列表失败');
        } finally {
          this.loading = false;
        }
      },

      refreshData() {
        this.DataList();
        this.$message.success('数据已刷新');
      },

      handleSizeChange(newSize) {
        this.pageSize = newSize;
        this.applyFilters();
      },

      handleCurrentChange(newPage) {
        this.pageNum = newPage;
        this.applyFilters();
      },

      getPaymentStatusType(payStatus) {
        switch (parseInt(payStatus)) {
          case 2: return 'success';
          case 1: return 'warning';
          case 0: return 'danger';
          default: return 'info';
        }
      },

      getPaymentStatusText(payStatus) {
        switch (parseInt(payStatus)) {
          case 2: return '已支付';
          case 1: return '支付中';
          case 0: return '待支付';
          default: return '未知';
        }
      },

      showGoods(row) {
        this.om = row;
        this.goods_list = row.goods || [];
        this.drawer = true;
      },

      goInvoice(row) {
        this.title1 = "上传发票";
        this.formData1.item = row;
        this.visible1 = true;
      },

      closeForm1() {
        this.visible1 = false;
      },

      handleInvoiceUpload() {
        this.closeForm1();
        this.refreshData();
        this.$message.success('发票上传成功');
      },

      isImageFile(url) {
        if (!url) return false;
        const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.webp'];
        return imageExtensions.some(ext => url.toLowerCase().includes(ext));
      },

      downloadFile(url, filename) {
        if (!url) {
          this.$message.warning('文件链接不存在');
          return;
        }

        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.target = '_blank';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        this.$message.success('开始下载文件');
      },

      async downPay(item) {
        try {
          const param = {
            access_token: sessionStorage.getItem('token'),
            company_id: sessionStorage.getItem('company_id'),
            order_id: item.id
          };

          const res = await this.$axios.yeeDown(param);
          if (res.code === 200 && res.data?.data) {
            this.downloadPDF(res.data.data, `凭证_${item.sn}.pdf`);
          }
        } catch (error) {
          console.error('下载凭证失败:', error);
          this.$message.error('下载凭证失败');
        }
      },

      downloadPDF(base64Data, filename) {
        try {
          const byteCharacters = atob(base64Data);
          const byteNumbers = new Array(byteCharacters.length);

          for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
          }

          const byteArray = new Uint8Array(byteNumbers);
          const blob = new Blob([byteArray], { type: 'application/pdf' });
          const url = URL.createObjectURL(blob);

          const link = document.createElement('a');
          link.href = url;
          link.download = filename;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          URL.revokeObjectURL(url);

          this.$message.success('下载成功');
        } catch (error) {
          console.error('PDF下载处理失败:', error);
          this.$message.error('下载处理失败');
        }
      },

      exportData() {
        if (this.filteredTableData.length === 0) {
          this.$message.warning('没有数据可以导出');
          return;
        }

        // 这里可以实现Excel导出逻辑
        // 示例：使用JSON导出
        const dataStr = JSON.stringify(this.filteredTableData, null, 2);
        const dataUri = 'data:application/json;charset=utf-8,'+ encodeURIComponent(dataStr);

        const exportFileName = `订单数据_${moment().format('YYYYMMDD_HHmmss')}.json`;
        this.downloadFile(dataUri, exportFileName);
      }
    }
  };
</script>

<style lang="scss" scoped>
  .oil-order-container {
    padding: 20px;
    background: #f5f7fa;

    .breadcrumb-wrapper {
      margin-bottom: 20px;

      .el-breadcrumb {
        font-size: 14px;

        :deep(.el-breadcrumb__item) {
          &:last-child {
            .el-breadcrumb__inner {
              color: #409EFF;
              font-weight: 600;
            }
          }
        }
      }
    }

    .main-card {
      border-radius: 8px;
      border: none;

      .section-title {
        display: flex;
        align-items: center;
        margin: 0;
        font-size: 16px;
        color: #303133;

        i {
          margin-right: 8px;
          color: #409EFF;
        }
      }
    }

    .search-section {
      margin-bottom: 24px;

      .search-header {
        margin-bottom: 16px;

        .title-with-filter {
          display: flex;
          justify-content: space-between;
          align-items: center;
        }
      }

      .toggle-button {
        display: flex;
        align-items: center;
        cursor: pointer;
        color: #409EFF;
        font-size: 14px;
        user-select: none;

        &:hover {
          color: #66b1ff;
        }

        .toggle-text {
          margin-right: 4px;
        }

        .toggle-icon {
          transition: transform 0.3s;
        }
      }

      .search-form-wrapper {
        padding: 20px;
        background: #fafafa;
        border-radius: 6px;
        border: 1px solid #ebeef5;
      }
    }

    .stats-section {
      margin-bottom: 24px;

      .stats-cards {
        .stats-card {
          margin-bottom: 0;
          border: 1px solid #ebeef5;
          transition: all 0.3s;

          &:hover {
            transform: translateY(-2px);
            box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
          }

          .stats-content {
            display: flex;
            align-items: center;

            .stats-icon {
              display: flex;
              align-items: center;
              justify-content: center;
              width: 48px;
              height: 48px;
              border-radius: 8px;
              margin-right: 12px;

              i {
                font-size: 24px;
                color: white;
              }

              &.primary {
                background: linear-gradient(135deg, #409EFF, #66b1ff);
              }

              &.warning {
                background: linear-gradient(135deg, #E6A23C, #eebe77);
              }

              &.success {
                background: linear-gradient(135deg, #67C23A, #85ce61);
              }

              &.info {
                background: linear-gradient(135deg, #909399, #a6a9ad);
              }
            }

            .stats-info {
              flex: 1;

              .stats-label {
                font-size: 12px;
                color: #909399;
                margin-bottom: 4px;
              }

              .stats-value {
                font-size: 18px;
                font-weight: 600;
                color: #303133;
                margin-bottom: 2px;

                &.amount {
                  color: #409EFF;
                }
              }

              .stats-count {
                font-size: 11px;
                color: #909399;
              }
            }
          }
        }
      }
    }

    .table-section {
      .table-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 16px;
      }

      .table-actions {
        display: flex;
        gap: 8px;

        .el-button {
          &.is-circle {
            padding: 7px;
          }
        }
      }

      .order-table {
        :deep(.el-table__header-wrapper) {
          th {
            background-color: #f8f9fa;
            font-weight: 600;
            color: #303133;
            white-space: nowrap;

            &.is-sortable {
              cursor: pointer;
            }
          }
        }

        :deep(.el-table__body-wrapper) {
          .time-display {
            .date {
              font-weight: 500;
              color: #303133;
            }

            .time {
              font-size: 11px;
              color: #909399;
              margin-top: 2px;
            }
          }

          .amount-cell {
            font-weight: 600;
            color: #409EFF;
          }

          .shop-display, .company-display {
            .shop-name {
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }

          .driver-info {
            .driver-name {
              font-weight: 500;
              margin-bottom: 2px;
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }

            .driver-sn {
              font-size: 11px;
              color: #909399;
            }
          }

          .car-number-tag {
            font-family: monospace;
            letter-spacing: 1px;
          }

          .invoice-status {
            .invoice-time {
              font-size: 11px;
              color: #909399;
              margin-top: 2px;
            }
          }

          .action-buttons {
            display: flex;
            justify-content: center;
            gap: 4px;

            .action-btn {
              width: 28px;
              height: 28px;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              transition: all 0.2s;

              &:hover {
                transform: scale(1.1);
              }

              &.invoice-btn:hover {
                color: #67C23A;
                background: #f0f9eb;
              }

              &.download-btn:hover {
                color: #E6A23C;
                background: #fdf6ec;
              }

              &.voucher-btn:hover {
                color: #409EFF;
                background: #ecf5ff;
              }

              &.detail-btn:hover {
                color: #909399;
                background: #f4f4f5;
              }
            }
          }
        }
      }

      .pagination-wrapper {
        margin-top: 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;

        .page-info {
          font-size: 12px;
          color: #909399;
        }
      }
    }

    .order-detail-drawer {
      :deep(.el-drawer__body) {
        padding: 0;
      }

      .drawer-content {
        height: 100%;
        display: flex;
        flex-direction: column;

        .drawer-header {
          padding: 20px;
          border-bottom: 1px solid #ebeef5;
          display: flex;
          justify-content: space-between;
          align-items: center;
          background: #fafafa;

          .drawer-title {
            margin: 0;
            font-size: 16px;
            color: #303133;

            i {
              color: #409EFF;
              margin-right: 8px;
            }
          }
        }

        .detail-content {
          flex: 1;
          overflow-y: auto;
          padding: 20px;

          .detail-card {
            margin-bottom: 20px;
            border: 1px solid #ebeef5;

            &:last-child {
              margin-bottom: 0;
            }

            .card-header {
              display: flex;
              justify-content: space-between;
              align-items: center;
              padding: 12px 20px;
              background: #fafafa;

              .card-title {
                font-weight: 500;
                color: #303133;

                i {
                  margin-right: 8px;
                  color: #409EFF;
                }
              }

              .card-actions {
                display: flex;
                gap: 8px;
              }

              .goods-count {
                font-size: 12px;
                color: #909399;
              }
            }

            .highlight-text {
              font-weight: 600;

              &.amount {
                color: #409EFF;
              }
            }

            .invoice-file {
              .file-preview {
                margin-top: 8px;
              }

              .invoice-image {
                width: 120px;
                height: 120px;
                border-radius: 4px;
                border: 1px solid #ebeef5;

                :deep(.image-slot) {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  width: 100%;
                  height: 100%;
                  color: #c0c4cc;
                }
              }
            }

            .goods-quantity {
              font-weight: 500;
              color: #303133;
            }
          }
        }
      }
    }
  }

  // 响应式设计
  @media (max-width: 768px) {
    .oil-order-container {
      padding: 12px;
    }

    .stats-cards {
      .el-col {
        margin-bottom: 12px;
      }
    }

    .search-form {
      .el-col {
        margin-bottom: 12px;
      }
    }

    .action-buttons {
      flex-wrap: wrap;
      gap: 4px;
    }

    .pagination-wrapper {
      flex-direction: column;
      gap: 10px;

      .page-info {
        text-align: center;
      }
    }
  }
</style>
